import { render, staticRenderFns } from "./Login2.vue?vue&type=template&id=090ca1fa&scoped=true&"
import script from "./Login2.vue?vue&type=script&lang=js&"
export * from "./Login2.vue?vue&type=script&lang=js&"
import style0 from "@/vendor/styles/pages/authentication.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./Login2.vue?vue&type=style&index=1&id=090ca1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ca1fa",
  null
  
)

export default component.exports